export default __webpack_public_path__ + "c25a3f4e5c2e904125f32a691b061303.png";